// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Button } from './button';

/**
 * @class Jsw.SmallButton
 * @extends Jsw.Button
 */
export const SmallButton = Class.create(Button, {
    _initConfiguration($super, config) {
        $super(config);

        this._cls = this._getConfigParam('cls', `s-btn${!this._title ? ' btn-icon-only' : ''}`);
    },
});



// WEBPACK FOOTER //
// ./jsw/small-button.js